import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Button,
  Sheet,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
  Typography,
  ButtonGroup,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import {
  activateMerchantRequest,
  activateMerchantReset,
  createMerchantAccountRequest,
  createMerchantAccountReset,
  deactivateMerchantRequest,
  deactivateMerchantReset,
  updateMerchantAccountRequest,
  updateMerchantAccountReset,
  viewMerchantRequest,
  viewMerchantReset,
} from "../../../store/actions";
import {
  AddCircleOutline,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  ReceiptLong,
} from "@mui/icons-material";
import { NAVIGATE_TO_MERCHANTTRANSACTIONSPAGE } from "../../../route/types";
import { NAVIGATE_TO_MERCHANTPROPERTIESPAGE } from "../../../route/types";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const MerchantViewPage = ({
  loginResult,

  viewMerchantStatus,
  viewMerchantResult,
  viewMerchantErrorMessage,

  activateMerchantStatus,
  activateMerchantResult,
  activateMerchantErrorMessage,

  deactivateMerchantStatus,
  deactivateMerchantResult,
  deactivateMerchantErrorMessage,

  createMerchantAccountStatus,
  createMerchantAccountResult,
  createMerchantAccountErrorMessage,

  updateMerchantAccountStatus,
  updateMerchantAccountResult,
  updateMerchantAccountErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { merchant_code } = state;

  const [deactivateModal, setDeactivateModal] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(0);
  const [code, setCode] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [remark, setRemark] = useState("");

  const [accountModal, setAccountModal] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountFsp, setAccountFsp] = useState("");
  const [accountType, setAccountType] = useState("COLLECTION");

  const resetAccountForm = () => {
    setAccountId(null);
    setAccountNumber("");
    setAccountFsp("");
    setAccountType("COLLECTION");
  };

  useEffect(() => {
    if (viewMerchantStatus === STATUS.SUCCESS) {
      setName(viewMerchantResult.name);
      setEmail(viewMerchantResult.email);
      setStatus(viewMerchantResult.status);
      setCode(viewMerchantResult.code);
      setAccounts(viewMerchantResult.accounts || []);
    } else if (viewMerchantStatus === STATUS.ERROR) {
      toast.error(viewMerchantErrorMessage);
      dispatch(viewMerchantReset());
    }

    if (activateMerchantStatus === STATUS.SUCCESS) {
      toast.success("Merchant activated successful");
      dispatch(viewMerchantRequest(loginResult.token, { code: merchant_code }));
      dispatch(activateMerchantReset());
    } else if (activateMerchantStatus === STATUS.ERROR) {
      toast.error(activateMerchantErrorMessage);
      dispatch(activateMerchantReset());
    }

    if (deactivateMerchantStatus === STATUS.SUCCESS) {
      toast.success("Merchant deactivated successful");
      setDeactivateModal(false);
      setRemark("");
      dispatch(viewMerchantRequest(loginResult.token, { code: merchant_code }));
      dispatch(deactivateMerchantReset());
    } else if (deactivateMerchantStatus === STATUS.ERROR) {
      toast.error(deactivateMerchantErrorMessage);
      dispatch(deactivateMerchantReset());
    }

    if (createMerchantAccountStatus === STATUS.SUCCESS) {
      toast.success("Merchant account added successful");
      setAccountModal(false);
      resetAccountForm();
      dispatch(viewMerchantRequest(loginResult.token, { code: merchant_code }));
      dispatch(createMerchantAccountReset());
    } else if (createMerchantAccountStatus === STATUS.ERROR) {
      toast.error(createMerchantAccountErrorMessage);
      dispatch(createMerchantAccountReset());
    }

    if (updateMerchantAccountStatus === STATUS.SUCCESS) {
      toast.success("Merchant account updated successful");
      setAccountModal(false);
      resetAccountForm();
      dispatch(viewMerchantRequest(loginResult.token, { code: merchant_code }));
      dispatch(updateMerchantAccountReset());
    } else if (updateMerchantAccountStatus === STATUS.ERROR) {
      toast.error(updateMerchantAccountErrorMessage);
      dispatch(updateMerchantAccountReset());
    }
  });

  useEffect(() => {
    if (merchant_code != "") {
      dispatch(viewMerchantRequest(loginResult.token, { code: merchant_code }));
    }
  }, []);

  // ------ actions -------------------------
  const activateMerchant = () => {
    const data = {
      code: merchant_code,
    };
    dispatch(activateMerchantRequest(loginResult.token, data));
  };

  const deactivateMerchant = (event) => {
    event.preventDefault();
    const data = {
      code: merchant_code,
      remark: remark,
    };
    dispatch(deactivateMerchantRequest(loginResult.token, data));
  };

  const openAddAccount = () => {
    resetAccountForm();
    setAccountModal(true);
  };

  const openEditAccount = (account) => {
    setAccountId(account.id);
    setAccountNumber(account.account_number || "");
    setAccountFsp(account.account_fsp || "");
    setAccountType(account.account_type || "COLLECTION");
    setAccountModal(true);
  };

  const submitAccount = (event) => {
    event.preventDefault();

    if (!accountNumber || !accountFsp || !accountType) {
      toast.error("Please fill all required information");
      return;
    }

    if (accountId) {
      const data = {
        id: accountId,
        code: merchant_code,
        account_number: accountNumber,
        account_fsp: accountFsp,
        account_type: accountType,
      };
      dispatch(updateMerchantAccountRequest(loginResult.token, data));
    } else {
      const data = {
        code: merchant_code,
        account_number: accountNumber,
        account_fsp: accountFsp,
        account_type: accountType,
      };
      dispatch(createMerchantAccountRequest(loginResult.token, data));
    }
  };

  const goToMerchantList = () => {
    navigate(-1);
  };

  const goToMerchantTransactions = () => {
    navigate(NAVIGATE_TO_MERCHANTTRANSACTIONSPAGE, {
      state: { merchant_code, merchant_name: name },
    });
  };

  const checkLoading = () => {
    if (
      viewMerchantStatus === STATUS.LOADING ||
      activateMerchantStatus === STATUS.LOADING ||
      deactivateMerchantStatus === STATUS.LOADING ||
      createMerchantAccountStatus === STATUS.LOADING ||
      updateMerchantAccountStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("Code", code),
    CreateItems("Name", name),
    CreateItems("Email", email),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Pending", 4: "Rejected" }[status],
    ),
  ];

  return (
    <Box>
      <PageTitle title={`${name} Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* ------ only admin can do this actions ------ */}
          {loginResult.role === 1 && (
            <>
              <Button
                color="success"
                startDecorator={<CheckCircle />}
                onClick={activateMerchant}
                disabled={status === 1}
              >
                Activate
              </Button>

              <Button
                color="danger"
                startDecorator={<DoNotDisturbOn />}
                onClick={() => setDeactivateModal(true)}
                disabled={status === 2}
              >
                Deactivate
              </Button>

              <Button
                color="primary"
                variant="outlined"
                startDecorator={<ReceiptLong />}
                onClick={goToMerchantTransactions}
              >
                View Transactions
              </Button>

              <Button
                color="primary"
                variant="outlined"
                startDecorator={<ReceiptLong />}
                onClick={() =>
                  navigate(NAVIGATE_TO_MERCHANTPROPERTIESPAGE, {
                    state: { merchant_code },
                  })
                }
              >
                View Properties
              </Button>
            </>
          )}

          <Button
            color="neutral"
            variant="outlined"
            onClick={goToMerchantList}
          >
            Back
          </Button>
        </Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* merchant details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Merchant Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Sheet>

          {/* merchant accounts */}
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Typography level="title-md">Merchant Accounts</Typography>

              {loginResult.role === 1 && (
                <Button
                  size="sm"
                  startDecorator={<AddCircleOutline />}
                  onClick={openAddAccount}
                >
                  Add Account
                </Button>
              )}
            </Stack>

            <Sheet
              className="OrderTableContainer"
              variant="outlined"
              sx={{
                display: "flex",
                borderRadius: "sm",
                flexShrink: 1,
                overflow: "auto",
                minHeight: 0,
              }}
            >
              <Table
                aria-labelledby="accountsTableTitle"
                stickyHeader
                hoverRow
                sx={{
                  "--TableCell-headBackground":
                    "var(--joy-palette-background-level2)",
                  "--Table-headerUnderlineThickness": "1px",
                  "--TableRow-hoverBackground":
                    "var(--joy-palette-background-level1)",
                  "--TableCell-paddingY": "4px",
                  "--TableCell-paddingX": "8px",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ width: 160, padding: "10px 6px" }}>
                      Account Number
                    </th>
                    <th style={{ width: 140, padding: "10px 6px" }}>FSP</th>
                    <th style={{ width: 140, padding: "10px 6px" }}>Type</th>
                    <th style={{ width: 70, padding: "10px 6px" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {accounts.length > 0 ? (
                    accounts.map((account) => (
                      <tr key={account.id}>
                        <td>
                          <Typography level="body-sm">
                            {account.account_number}
                          </Typography>
                        </td>
                        <td>
                          <Typography level="body-sm">
                            {account.account_fsp}
                          </Typography>
                        </td>
                        <td>
                          <Typography level="body-sm">
                            {account.account_type}
                          </Typography>
                        </td>
                        <td>
                          {loginResult.role === 1 && (
                            <ButtonGroup variant="soft" size="sm">
                              <Button
                                title="Edit"
                                color="primary"
                                onClick={() => openEditAccount(account)}
                              >
                                <EditOutlined />
                              </Button>
                            </ButtonGroup>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <Typography level="body-sm">
                          No accounts linked to this merchant.
                        </Typography>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Sheet>
          </Box>
        </Box>
      </Box>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate merchant:" + name}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateMerchant}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* deactivation reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter deactivation reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* add / edit merchant account modal */}
      <Modal open={accountModal}>
        <ModalDialog
          aria-labelledby="merchant-account-title"
          aria-describedby="merchant-account-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setAccountModal(false)}
          />
          <DialogTitle id="merchant-account-title">
            {accountId ? "Edit Merchant Account" : "Add Merchant Account"}
          </DialogTitle>
          <DialogContent id="merchant-account-description">
            Account numbers must be unique across all merchants.
          </DialogContent>
          <Stack
            component={"form"}
            onSubmit={submitAccount}
            gap={2}
            sx={{ mt: 2 }}
          >
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Account Number</FormLabel>
              <Input
                type="text"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                placeholder="Enter account number"
              />
            </FormControl>

            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>FSP (Partner)</FormLabel>
              <Input
                type="text"
                value={accountFsp}
                onChange={(e) => setAccountFsp(e.target.value)}
                placeholder="Enter FSP code e.g. FSP955364"
              />
            </FormControl>

            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Account Type</FormLabel>
              <Select
                value={accountType}
                onChange={(event, newValue) => setAccountType(newValue)}
                required
              >
                <Option value="COLLECTION">COLLECTION</Option>
                <Option value="DISBURSEMENT">DISBURSEMENT</Option>
              </Select>
            </FormControl>

            <Button type="submit" fullWidth>
              {accountId ? "SAVE CHANGES" : "ADD ACCOUNT"}
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ merchant, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    viewMerchantStatus,
    viewMerchantResult,
    viewMerchantErrorMessage,

    activateMerchantStatus,
    activateMerchantResult,
    activateMerchantErrorMessage,

    deactivateMerchantStatus,
    deactivateMerchantResult,
    deactivateMerchantErrorMessage,

    createMerchantAccountStatus,
    createMerchantAccountResult,
    createMerchantAccountErrorMessage,

    updateMerchantAccountStatus,
    updateMerchantAccountResult,
    updateMerchantAccountErrorMessage,
  } = merchant;

  return {
    loginResult,

    viewMerchantStatus,
    viewMerchantResult,
    viewMerchantErrorMessage,

    activateMerchantStatus,
    activateMerchantResult,
    activateMerchantErrorMessage,

    deactivateMerchantStatus,
    deactivateMerchantResult,
    deactivateMerchantErrorMessage,

    createMerchantAccountStatus,
    createMerchantAccountResult,
    createMerchantAccountErrorMessage,

    updateMerchantAccountStatus,
    updateMerchantAccountResult,
    updateMerchantAccountErrorMessage,
  };
};

export default connect(mapStateToProps, {})(MerchantViewPage);
